import { ArrowUpRight } from "lucide-react";

const LOGO = "/average-af-logo.png";
const AVERAGE_AF_URL = "https://averageaf.com/";

export const ParentCompanySection = () => (
  <section className="max-w-6xl mx-auto px-5 sm:px-8 pb-14" data-testid="parent-company-section">
    <div className="rounded-2xl bg-white border border-[#1B2A41]/10 shadow-lg px-6 sm:px-10 py-8 flex flex-col md:flex-row items-center gap-8">
      <a href={AVERAGE_AF_URL} target="_blank" rel="noopener noreferrer" className="flex-shrink-0" data-testid="average-af-logo-link">
        <img src={LOGO} alt="Average AF" data-testid="average-af-logo" className="h-12 sm:h-14 w-auto max-w-[240px] sm:max-w-[280px] object-contain" />
      </a>
      <div className="text-center md:text-left">
        <p className="font-type text-xs uppercase tracking-[0.3em] text-[#5A7355] mb-2">Part of something bigger</p>
        <p className="text-sm sm:text-base text-[#1E2830]/85 leading-relaxed max-w-prose">
          <strong>The R.O.A.N Initiative</strong> is a project under the <strong>Intellectual</strong> pillar
          <br className="hidden md:block" /> of the master company <strong>Average AF</strong>.
        </p>
        <a
          href={AVERAGE_AF_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="average-af-more-info-link"
          className="mt-4 inline-flex items-center gap-2 font-type font-bold text-sm uppercase tracking-wider text-[#E2705A] hover:text-[#c95a46] transition-colors"
        >
          For more information click here <ArrowUpRight className="w-4 h-4" />
        </a>
        <p className="mt-1 text-xs text-[#1E2830]/60 font-type">Average AF — We aim to be better, not best</p>
      </div>
    </div>
  </section>
);
